import { useCallback } from 'react';
import { firma } from '../content';
import { Letterhead } from './Letterhead';
import { BusinessCard } from './BusinessCard';
import { Flyer } from './Flyer';
import './print-index.css';

type TemplateId = 'letterhead' | 'business-card' | 'flyer';

/**
 * Schlichte Uebersicht der drei Drucksachen. Zeigt jede Vorlage in ihrem
 * eigenen Erscheinungsbild (siehe letterhead.css/business-card.css/flyer.css)
 * und traegt je einen Druckknopf.
 *
 * WARUM data-print-only statt drei getrennter Fenster: window.print()
 * druckt immer das gesamte Dokument. Da alle drei Vorlagen gemeinsam auf
 * dieser Seite stehen, markiert der Klick auf einen Druckknopf zuerst, WELCHE
 * Vorlage gemeint ist (Attribut auf <body>) - print-index.css blendet die
 * beiden anderen dann per @media print aus. So bleibt "je einen Druckknopf"
 * auch technisch wahr, statt drei Vorlagen auf einmal zu drucken.
 */
export function PrintIndex() {
  const drucken = useCallback((vorlage: TemplateId) => {
    document.body.dataset.printOnly = vorlage;
    const zuruecksetzen = () => {
      delete document.body.dataset.printOnly;
      window.removeEventListener('afterprint', zuruecksetzen);
    };
    window.addEventListener('afterprint', zuruecksetzen);
    window.print();
  }, []);

  return (
    <div className="print-index">
      <header className="print-index__intro">
        <p className="print-index__eyebrow">{firma.name}</p>
        <h1>Drucksachen</h1>
        <p>Briefbogen, Visitenkarte und Angebotsflyer im Markenauftritt.</p>
      </header>

      <section className="print-index__item" data-template="letterhead">
        <div className="print-index__item-head">
          <h2>Briefbogen</h2>
          <button type="button" className="print-index__button" onClick={() => drucken('letterhead')}>
            Drucken
          </button>
        </div>
        <div className="print-index__preview">
          <Letterhead />
        </div>
      </section>

      <section className="print-index__item" data-template="business-card">
        <div className="print-index__item-head">
          <h2>Visitenkarte</h2>
          <button type="button" className="print-index__button" onClick={() => drucken('business-card')}>
            Drucken
          </button>
        </div>
        <div className="print-index__preview">
          <BusinessCard />
        </div>
      </section>

      <section className="print-index__item" data-template="flyer">
        <div className="print-index__item-head">
          <h2>Angebotsflyer</h2>
          <button type="button" className="print-index__button" onClick={() => drucken('flyer')}>
            Drucken
          </button>
        </div>
        <div className="print-index__preview">
          <Flyer />
        </div>
      </section>
    </div>
  );
}
